//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { imageUrl } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import PrintReceiptDejTab from "./PrintReceiptDejTab";
import PrintReceiptStandardTab from "./PrintReceiptStandardTab";
import PrintReceiptDetailDejTab from "./PrintReceiptDetailDejTab";
import PrintReceiptDetailStandardTab from "./PrintReceiptDetailStandardTab";
var convert = require("decimal-number-to-words");
import unity from "@/unity/unity";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

// เพิ่มตรงนี้
import { generateReceiptPDF } from "@/utils/pdfReceiptGenerator";

import {
  generateReceiptDetailPDF,
  downloadReceiptDetailPDF,
  printReceiptDetailPDF,
} from "@/utils/pdfReceiptDetailGenerator";

export default {
  name: "NewAdvance",
  data() {
    return {
      pdfBlob:null,
      pdfObj:null,
      dialogPDF:false,
      getcompany_id: 0,
      pdfMakeReady: false,
      mockData: {
        main_data: null, // จะโยนค่าเข้ามาตอนเรียกใช้
        main_data_detail: null, // เพิ่มบรรทัดนี้สำหรับ Detail Receipt
      },

      dialogSelectClientInfoReceipt: "primary",

      currency_print: "",
      vat_type_list: [
        { id: "I", name: "Include Vat" },
        { id: "E", name: "Exclude Vat" },
      ],
      check_cus_name: false,
      date_rc: null,
      menu2: false,
      bank_name_show: "",
      bank_no_show: "",
      bank_name: "",
      bank_no: "",
      showinv_rid: "####",
      status_check: false,
      main_id: 0,
      main_customer_id: 0,
      dataAddRc_H: {},
      dataAddRc_D: {},
      payment_by: "",
      payment_comment: "",
      company_trc: "",
      customer_data: [],
      main_inv_id: [],
      res_amout: [],
      res_docRef: [],
      res_so_detail: [],
      res_ts_detail: [],
      res_ad_detail: [],
      res_ms_detail: [],
      dataAll: [],
      desserts: [],
      mDataArray: [],
      customer_code: "",
      customer_name: "",
      doc_ref: "",
      inv_id_by: 0,
      invoice_address: "",
      currency: "",
      tax_id: "",
      branch: "",
      exchange_rate: 0,
      vat_type: "",
      wth_rate: 0,
      wth_ratetotal: 0,
      tax_ratetotal: 0,
      amount_total: 0,
      inv_subtotal: 0,
      payment_term: 0,
      amoumt_t: 0,
      attention: "",
      vat: "",
      po_no: "",
      headers: [
        {
          text: "No.",
          value: "inv_seq",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service Details",
          align: "center",
          value: "inv_detail",
          class: "bg-colorth texttablehcenter",
          width: "35%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "inv_qty",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          text: "Price Per Unit",
          value: "inv_price",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Total Price  ",
          value: "inv_lineamount",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          align: "center",
          width: "60px",
          divider: true,
          sortable: false,
        },
      ],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogEdit: false,
      dataedit_service: {
        inv_lineamount: 0,
      },
      editedIndex: -1,
      dialogDeleteServic: false,
      dialogDeleteRecevie: false,
      //print va start
      setlanguage: language.en,
      dialogSelectPrint: false,
      dialogSelect: "1",

      currency_show: "",
      payment_by_print: "",
      main_id_print: 0,
      inv_id: 0,
      inv_detail_id: 0,
      tax_detail_rate: 0,
      showprint: "",
      showprintDetail: "",
      textamount_total_en: "",
      print_header_list: [
        {
          id: "1",
          com_title: "RECEIPT / TAX INVOICE",
          com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_title_th: "ใบเสร็จรับเงิน",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],

      print_header_list_detail: [
        {
          id: "1",
          com_title: "RECEIPT / TAX INVOICE",
          com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_title_th: "ใบเสร็จรับเงิน",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],
      print_header: null,
      print_detail_header: null,
      print_table_detail: [],
      print_table_Rcdetail: [],
      pageAll: 1,
      pageAllDetail: 1,
      opensummarize: false,
      opensummarizeDetail: false,
      datashowAll: [],
      datashowAllDetail: [],
      dataforshowprpo: [],
      setdatatoshow: [],
      setdatatoshowDetail: [],
      branch_cus: "",
      checklawoffice: false,
      heighttabledetail: "0px",
      //print va end
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
    PrintReceiptDejTab,
    PrintReceiptStandardTab,
    PrintReceiptDetailDejTab,
    PrintReceiptDetailStandardTab,
    PdfPreviewDialog,
  },
  computed: {
    computedDateFormatted() {
      console.log('date_rc =', this.date_rc);
      console.log('formatted =', this.formatDate(this.date_rc));

      return this.formatDate(this.date_rc);
    },
    dataToUse() {
      return this.mockData.main_data || {};
    },

    header() {
      return this.dataToUse.print_header || {};
    },

    items() {
      const datashowAll = this.dataToUse.datashowAll || [];
      const allItems = [];

      datashowAll.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrint() {
      return this.dataToUse.currency_print || "";
    },

    exchangeRate() {
      return this.dataToUse.exchange_rate || "";
    },

    showCurrencyColumn() {
      const curr = this.currencyPrint.toUpperCase();
      return curr === "US" || curr === "USD";
    },

    dataToUseDetail() {
      return this.mockData.main_data_detail || {};
    },

    headerDetail() {
      return this.dataToUseDetail.print_header || {};
    },

    itemsDetail() {
      const datashowAllDetail = this.dataToUseDetail.datashowAllDetail || [];
      const allItems = [];

      datashowAllDetail.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrintDetail() {
      return this.dataToUseDetail.currency_print || "";
    },

    exchangeRateDetail() {
      return this.dataToUseDetail.exchange_rate || "";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    this.$forceUpdate();
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.loaddataRc();
    await this.loadCustomer();
    await this.loaddataRc_D();
    await this.loadInvByID();

    this.waitForPdfMakeReady()
      .then(() => {
        this.pdfMakeReady = true;
      })
      .catch((error) => {
        // console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("ไม่สามารถโหลด pdfMake ได้ กรุณาลองใหม่อีกครั้ง");
      });

    this.$hideLoader();
  },
  methods: {
        getFileName() {
  return `Receipt_${this.print_header?.inv_id??''}.pdf`
},
    initialize() {
      // logic สำหรับโหลด/รีเซ็ตข้อมูลตาราง
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);
            // console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // print start
    async loadinv_handcal() {
      const res_rc_detail = await api.billing_expensegetDataReceiveDByID(
        this.main_id_print,
      );
      this.desserts = res_rc_detail.data;

      this.desserts.forEach(async (item, index) => {
        item.inv_qty = tolocalestringnumber(item.inv_qty);
        item.inv_price = tolocalestringnumber(
          item.inv_lineamount / item.inv_qty,
        );
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);
        if (index == this.desserts.length - 1) {
          this.mDataArrayforinv = this.desserts;
        }
      });
    },
    async loadCustomer() {
      if (this.main_customer_id != 0) {
        const res_customer = await api.getCustomersById(this.main_customer_id);
        if (res_customer.data[0]) {
          this.vat_type = res_customer.data[0].vat_type;
        }
      }
    },
    async onClicktoPrint() {
      this.main_id_print = this.$route.params.id;
      await this.loadinv_handcal();
      await this.loadCustomer();
      await this.SumDataT();
      this.dialogSelectPrint = true;
    },

    //print sumary start
    async loadRef_TypeRcById() {
      this.print_header = {};
      const res_inv_id = await api.billing_expensegetDataReceiveDByIDOne(
        this.main_id_print,
      );

      this.inv_id = res_inv_id.data[0].inv_hid;
      this.tax_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      const res_hresult = await api.billing_expense_getdataByIdInvoice_HRC(
        res_inv_id.data[0].inv_hid,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[0];
        this.checklawoffice = false;
        this.heighttabledetail = "270px";
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[1];
        this.checklawoffice = true;
        this.heighttabledetail = "300px";
        this.print_header.com_title = "RECEIPT";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.print_header.inv_company_address2 =
          res_hresult.data[0].inv_company_address2;
        this.print_header.inv_subdistrict = res_hresult.data[0].inv_subdistrict;
        this.print_header.inv_district = res_hresult.data[0].inv_district;
        this.print_header.inv_province = res_hresult.data[0].inv_province;
        this.print_header.inv_postcode = res_hresult.data[0].inv_postcode;
        this.print_header.inv_country = res_hresult.data[0].inv_country;

        this.getcompany_id = res_hresult.data[0].company_inv;
        this.heighttabledetail = "365px";
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_header.com_name = res_hresult.data[0].com_name;
        this.print_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_hresult.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;
      }

      this.print_header.company_inv = res_hresult.data[0].company_inv;

      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_header.payment_by = "Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_header.payment_by = "Cheque";
      } else {
        this.print_header.payment_by = "Other";
      }

      this.print_header.payment_detail = res_inv_id.data[0].payment_comment;
      this.print_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_header.invoice_date = res_hresult.data[0].date_show;

      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = this.tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
    },
    async loadMainInvSoData() {
      // var tmp_inv_data;
      // this.print_header = {};
      const res_inv_so = await api.billing_expense_getdataByIdInvoice_HRC(
        this.inv_id,
      );

      if (res_inv_so.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[0];
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[1];
        this.print_header.com_title = "RECEIPT";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_inv_so.data[0].company_inv;
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_header.com_name = res_inv_so.data[0].com_name;
        this.print_header.inv_company_address =
          res_inv_so.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_inv_so.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_inv_so.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_inv_so.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_inv_so.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_inv_so.data[0].inv_company_name_th;
      }
      this.currency_show = res_inv_so.data[0].currency;
      this.print_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_header.addressall = res_inv_so.data[0].addressall;
      this.print_header.customer_address = res_inv_so.data[0].customer_address;

      this.print_header.province_invoice = res_inv_so.data[0].province_invoice;
      this.print_header.country_invoice = res_inv_so.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_inv_so.data[0].zipcode_invoice;

      this.print_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      // this.print_header.customer_taxid = res_inv_so.data[0].customer_taxid;
      this.print_header.customer_taxid = `${res_inv_so.data[0].customer_taxid
        } ${res_inv_so.data[0].customer_branch &&
          res_inv_so.data[0].customer_branch !== ""
          ? ` / ${res_inv_so.data[0].customer_branch}`
          : ""
        }`;
      this.branch_cus = res_inv_so.data[0].customer_branch;
      this.print_header.tax_rate = this.tax_rate;
      // alert(this.branch_cus)
    },
    async loadInvSoData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;

      const res_inv_rc = await api.billing_expensegetDataPrint(
        this.main_id_print,
      );

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
        };

        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;

        data.amount = Number(item.amount);
        if (this.vat_type == "E") {
          data.amount_s = Number(item.amount);
        } else if (this.vat_type == "I") {
          data.amount_s = Number(item.amount);
        } else {
          return;
        }
        data.amount_s = parseFloat(data.amount_s);
        this.print_table_detail.push(data);
        sub_total = Number(sub_total) + Number(data.amount);
      });
      sub_total = sub_total.toFixed(2);

      if (this.vat_type == "E") {
        this.print_header.sub_total = parseFloat(Number(sub_total).toFixed(2));
        this.print_header.tax_rate_amount = parseFloat(
          Number((this.print_header.sub_total * this.vat) / 100).toFixed(2),
        );
        this.print_header.amount_total = parseFloat(
          Number(this.print_header.sub_total) +
          Number(this.print_header.tax_rate_amount),
        );
      } else if (this.vat_type == "I") {
        this.print_header.amount_total = parseFloat(sub_total);
        this.print_header.sub_total = parseFloat(
          (sub_total * 100) / (100 + Number(this.vat)),
        );
        this.print_header.tax_rate_amount = parseFloat(
          this.print_header.amount_total - this.print_header.sub_total,
        );
      } else {
        return;
      }

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total.toFixed(2),
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        let thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        let thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        let [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;

        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }
        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        let result = "";
        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
    },
    async loadInvSoDataOth() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      var gran_total = 0;
      var sub_total_oth = 0;
      var gran_total_oth = 0;
      const res_inv_rc = await api.billing_expensegetDataPrint(
        this.main_id_print,
      );

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
          amount_s: 0,
          amount_s_ex: 0,
          amount_sub: 0,
        };
        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;
        data.amount = Number(item.inv_amount_total);
        if (this.vat_type == "E") {
          data.amount_s = Number(item.inv_amount_total).toFixed(2);
        } else if (this.vat_type == "I") {
          // data.amount_s = (data.amount  inv_sub_total(data.amount * (this.vat / 100))).toFixed(2);
          data.amount_s = Number(item.inv_amount_total).toFixed(2);
        } else {
          return;
        }
        data.amount_sub = Number(item.inv_sub_total).toFixed(2);

        data.amount_s_ex = Number(data.amount_s) * this.exchange_rate;
        data.amount_s_ex = Number(data.amount_s_ex.toFixed(2));
        data.amount_s = parseFloat(data.amount_s);
        data.amount_s_ex = parseFloat(data.amount_s_ex);
        this.print_table_detail.push(data);

        this.curency_show_tb = "";
        this.curency_show_tb = item.currency;

        sub_total_oth = Number(sub_total_oth) + Number(data.amount_sub);
        gran_total_oth = Number(gran_total_oth) + Number(data.amount_s);
        gran_total = Number(gran_total) + Number(data.amount_s_ex);
      });
      sub_total_oth = sub_total_oth.toFixed(2);
      gran_total_oth = gran_total_oth.toFixed(2);
      gran_total = gran_total.toFixed(2);

      // if(this.vat_type == "E"){
      //   this.print_header.sub_total_oth = parseFloat(Number(gran_total_oth).toFixed(2));
      //   this.print_header.tax_rate_amount_oth = parseFloat(Number(this.print_header.sub_total_oth * (this.vat/100)).toFixed(2));
      //   this.print_header.amount_total_oth = parseFloat(Number(this.print_header.sub_total_oth + this.print_header.tax_rate_amount_oth).toFixed(2));

      //   this.print_header.amount_total = parseFloat(Number(this.print_header.amount_total_oth * this.exchange_rate).toFixed(2));
      //   this.print_header.sub_total = parseFloat(Number(this.print_header.sub_total_oth * this.exchange_rate).toFixed(2));
      //   this.print_header.tax_rate_amount = parseFloat(this.print_header.amount_total - this.print_header.sub_total);
      //   //
      // }else  if(this.vat_type == "I"){
      this.print_header.amount_total_oth = parseFloat(
        Number(gran_total_oth).toFixed(2),
      );
      this.print_header.sub_total_oth = parseFloat(
        Number(sub_total_oth).toFixed(2),
      );
      this.print_header.tax_rate_amount_oth = parseFloat(
        this.print_header.amount_total_oth - this.print_header.sub_total_oth,
      );

      this.print_header.amount_total = parseFloat(
        Number(this.print_header.amount_total_oth * this.exchange_rate).toFixed(
          2,
        ),
      );
      this.print_header.sub_total = parseFloat(
        Number(this.print_header.amount_total / (1 + this.vat / 100)).toFixed(
          2,
        ),
      );
      this.print_header.tax_rate_amount = parseFloat(
        this.print_header.amount_total - this.print_header.sub_total,
      );
      // }else{

      // }

      // this.print_header.amount_total_oth = parseFloat(gran_total_oth);
      // this.print_header.amount_total = parseFloat(gran_total);

      // sub_total_oth = (this.print_header.amount_total_oth / (1 + (this.vat / 100))).toFixed(2)
      // sub_total = (this.print_header.amount_total / (1 + (this.vat / 100))).toFixed(2)
      // this.print_header.sub_total_oth = parseFloat(sub_total_oth);
      // this.print_header.sub_total = parseFloat(sub_total);

      // this.print_header.tax_rate_amount_oth = parseFloat(this.print_header.amount_total_oth - sub_total_oth)
      // this.print_header.tax_rate_amount = parseFloat(this.print_header.amount_total - sub_total)

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total.toFixed(2),
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          var numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            var units = thaiUnits[numArrays.length - index - 1];
            var digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        var numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          var unit = thaiUnits[numArray.length - index - 1];
          var digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        var result = "";
        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
      // this.print_header.sub_total = sub_total;
    },
    async checkcontent() {
      // เคลียร์ข้อมูลก่อน
      this.datashowAll = [];
      this.setdatatoshow = [];

      // จำนวนบรรทัดสูงสุดต่อหน้า (ไม่รวม footer)
      const linedetailprpo = 18;

      // ความยาวของข้อความที่คิดว่าแสดงได้ต่อบรรทัด
      const datainlineprpo = 80;

      // กำหนดว่าหน้าสุดท้ายจะมี footer ที่กินพื้นที่กี่บรรทัด
      const footerLines = 5;

      // ตัวแปรช่วยเก็บข้อมูลชั่วคราว
      let getdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;

      // วนข้อมูลทีละรายการ
      for (let i = 0; i < this.print_table_detail.length; i++) {
        // เตรียมข้อมูลตรวจความยาว (ใช้วัดจำนวนบรรทัด)
        let lengthofdataforshowprpo = this.print_table_detail[i].inv_id.length;

        // อักษรไทยบางตัวที่ไม่กินความกว้าง ต้องหักออกจากความยาวที่ใช้ในการคำนวณ
        const zeroWidthChars = [
          "่",
          "้",
          "๊",
          "๋",
          "ิ",
          "ี",
          "ึ",
          "ื",
          "ุ",
          "ู",
          "ั",
          "็",
        ];

        // หักอักขระพิเศษที่ไม่กินพื้นที่ออกจากความยาว
        for (let j = 0; j < this.print_table_detail[i].inv_id.length; j++) {
          if (zeroWidthChars.includes(this.print_table_detail[i].inv_id[j])) {
            lengthofdataforshowprpo--;
          }
        }

        // คำนวณว่าใช้กี่บรรทัด
        const newhllinedetails = Math.ceil(
          lengthofdataforshowprpo / datainlineprpo,
        );

        // ใส่หมายเลขบรรทัด
        this.print_table_detail[i].no = i + 1;

        // ปรับจำนวนบรรทัดต่อหน้าสำหรับหน้าสุดท้าย
        let currentPageLineLimit = linedetailprpo;
        const isLastItem = i === this.print_table_detail.length - 1;

        // ถ้าเป็นหน้าสุดท้าย ให้ลดจำนวนบรรทัดเผื่อ footer
        if (isLastItem) {
          currentPageLineLimit -= footerLines;
        }

        // ถ้าข้อมูลนี้ทำให้บรรทัดเกินหน้า → แยกหน้าใหม่
        if (hllinedetails + newhllinedetails > currentPageLineLimit) {
          // เก็บหน้าปัจจุบันไว้
          this.setdatatoshow[this.pageAll - 1] = getdata;

          // ขึ้นหน้าใหม่
          this.pageAll++;
          hllinedetails = 0;
          getdata = [];

          // ใส่รายการนี้เป็นรายการแรกของหน้าใหม่
          getdata.push(this.print_table_detail[i]);
          hllinedetails += newhllinedetails;

          // ถ้าเป็นรายการสุดท้าย ให้เก็บไว้เลย
          if (isLastItem) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
          }
        } else {
          // ถ้ายังไม่เกินหน้า → เพิ่มรายการเข้าไปในหน้าปัจจุบัน
          hllinedetails += newhllinedetails;
          getdata.push(this.print_table_detail[i]);

          // ถ้าเป็นรายการสุดท้าย → เก็บหน้าไว้
          if (isLastItem) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
          }
        }
      }

      // เปิดหน้าสรุป (อาจใช้แสดงหน้า preview)
      this.opensummarize = true;

      // ใส่ flag 'lastdata' ให้กับแถวสุดท้ายของหน้าสุดท้าย
      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem === this.setdatatoshow.length - 1) {
          item[item.length - 1].lastdata = "lastindex";
        }
        this.datashowAll.push(item);
      });
    },
    async exportToPDF() {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    //print summary end
    //print detail start
    async loadRef_TypeRcDetailById() {
      this.print_detail_header = {};
      const res_inv_id = await api.billing_expensegetDataReceiveDByIDOne(
        this.main_id_print,
      );

      this.inv_detail_id = res_inv_id.data[0].inv_hid;
      this.tax_detail_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      let inv_no = "";
      res_inv_id.data.forEach((item, index) => {
        if (index < res_inv_id.data.length - 1) {
          inv_no = inv_no + item.inv_id + ", ";
        } else {
          inv_no = inv_no + item.inv_id;
        }
      });

      const res_hresult = await api.billing_expense_getdataByIdInvoice_HRC(
        res_inv_id.data[0].inv_hid,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[0];
        this.checklawoffice = false;
        this.heighttabledetail = "270px";
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[1];
        this.checklawoffice = true;
        this.heighttabledetail = "300px";
        this.print_detail_header.com_title = "RECEIPT";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.print_detail_header.inv_company_address2 =
          res_hresult.data[0].inv_company_address2;
        this.print_detail_header.inv_subdistrict =
          res_hresult.data[0].inv_subdistrict;
        this.print_detail_header.inv_district =
          res_hresult.data[0].inv_district;
        this.print_detail_header.inv_province =
          res_hresult.data[0].inv_province;
        this.print_detail_header.inv_postcode =
          res_hresult.data[0].inv_postcode;
        this.print_detail_header.inv_country = res_hresult.data[0].inv_country;

        this.getcompany_id = res_hresult.data[0].company_inv;
        this.heighttabledetail = "365px";
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_detail_header.com_name = res_hresult.data[0].com_name;
        this.print_detail_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_detail_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_detail_header.inv_company_tel =
          res_hresult.data[0].inv_company_tel;
        this.print_detail_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_detail_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_detail_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;
      }
      this.print_detail_header.company_inv = res_hresult.data[0].company_inv;
      this.print_detail_header.invoice_no = inv_no;
      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_detail_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_detail_header.payment_by = "Bank Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_detail_header.payment_by = "Bank Cheque";
      }
      this.print_detail_header.payment_detail =
        res_inv_id.data[0].payment_comment;
      this.print_detail_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_detail_header.invoice_date = res_hresult.data[0].date_show;

      this.print_detail_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_detail_header.tax_rate = this.tax_detail_rate;
      this.print_detail_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
    },
    async loadMainRcData() {
      // this.print_detail_header = {};
      // var tmp_inv_data;
      const res_inv_so = await api.billing_expense_getdataByIdInvoice_HRC(
        this.inv_detail_id,
      );
      if (res_inv_so.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[0];
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[1];
        this.print_detail_header.com_title = "RECEIPT";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_inv_so.data[0].company_inv;
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_detail_header.com_name = res_inv_so.data[0].com_name;
        this.print_detail_header.inv_company_address =
          res_inv_so.data[0].inv_company_address;
        this.print_detail_header.inv_company_branch =
          res_inv_so.data[0].inv_company_branch;
        this.print_detail_header.inv_company_tel =
          res_inv_so.data[0].inv_company_tel;
        this.print_detail_header.inv_company_email =
          res_inv_so.data[0].inv_company_email;
        this.print_detail_header.inv_tax_id = res_inv_so.data[0].inv_tax_id;
        this.print_detail_header.inv_company_name_th =
          res_inv_so.data[0].inv_company_name_th;
      }

      this.currency_show = res_inv_so.data[0].currency;
      this.print_detail_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_detail_header.addressall = res_inv_so.data[0].addressall;
      this.print_detail_header.customer_address =
        res_inv_so.data[0].customer_address;

      this.print_detail_header.province_invoice =
        res_inv_so.data[0].province_invoice;
      this.print_detail_header.country_invoice =
        res_inv_so.data[0].country_invoice;
      this.print_detail_header.zipcode_invoice =
        res_inv_so.data[0].zipcode_invoice;

      this.print_detail_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_detail_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_detail_header.customer_taxid =
        res_inv_so.data[0].customer_taxid;
      this.branch_cus = res_inv_so.data[0].customer_branch;
      this.print_detail_header.tax_rate = this.vat;
    },
    async loadRcData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      const res_inv_rc = await api.billing_expensegetDataReceiveDByID(
        this.main_id_print,
      );

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          description: "",
          quantity: 0,
          amount: 0,
        };

        data.description = item.inv_detail;
        data.quantity = parseFloat(item.inv_qty);
        data.amount = parseFloat(item.inv_lineamount);
        this.print_table_Rcdetail.push(data);
        sub_total = sub_total + parseFloat(item.inv_lineamount);
      });
      if (this.vat_type == "E") {
        this.print_detail_header.sub_total = parseFloat(
          Number(sub_total).toFixed(2),
        );
        this.print_detail_header.tax_rate_amount = parseFloat(
          Number(
            (this.print_detail_header.sub_total * this.tax_detail_rate) / 100,
          ).toFixed(2),
        );
        this.print_detail_header.amount_total = parseFloat(
          this.print_detail_header.sub_total +
          this.print_detail_header.tax_rate_amount,
        );
      } else if (this.vat_type == "I") {
        this.print_detail_header.amount_total = parseFloat(
          Number(sub_total).toFixed(2),
        );
        this.print_detail_header.sub_total = parseFloat(
          Number(sub_total / (1 + this.tax_detail_rate / 100)).toFixed(2),
        );
        this.print_detail_header.tax_rate_amount = parseFloat(
          this.print_detail_header.amount_total -
          this.print_detail_header.sub_total,
        );
      } else {
      }

      // this.textamount_total_en = convert.toWords(
      //   this.print_detail_header.amount_total.toFixed(2)
      // );

      //check lag
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_detail_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_detail_header.amount_total.toFixed(2),
        );

        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        var result = "";

        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_detail_header.amount_total =
          Math.round(this.print_detail_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_detail_header.amount_total.toString().split(".");

        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
    },
    async checkcontentdetail() {
      this.datashowAllDetail = [];
      // alert(data.length);
      this.setdatatoshowDetail = [];
      let linedetailprpo = 17;
      let datainlineprpo = 50;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAllDetail = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_Rcdetail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_Rcdetail[i].description
          .length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_Rcdetail[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_Rcdetail[i].description.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        getnewdata.push(this.print_table_Rcdetail[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
          this.pageAllDetail++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_Rcdetail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_Rcdetail[i]);

          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizeDetail = true;

      this.setdatatoshowDetail.forEach((item, iitem) => {
        if (iitem == this.setdatatoshowDetail.length - 1) {
          item[this.setdatatoshowDetail[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAllDetail.push(item);
      });
    },

    async exportToPDFDetail() {
      this.showprintDetail = "";

      const element = document.getElementById("mydivhtmltobaseDetail");
      const opt = {
        margin: [0, 0, 0, 0],
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: {
          scale: 1.5,
          dpi: 144,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
      };

      try {
        let abcd = await html2pdf()
          .from(element)
          .set(opt)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();

            // ลบหน้าสุดท้ายก็ต่อเมื่อมีมากกว่า 1 หน้าเท่านั้น
            if (totalPages > 1) {
              pdf.deletePage(totalPages);
            }

            return pdf.output("bloburl");
          });

        window.open(abcd);
        let blob = await fetch(abcd).then((r) => r.blob());
      } catch (err) {
        // console.error("PDF export failed:", err);
      } finally {
        this.showprintDetail = "display:none;";
      }

      return;
    },

    async printReceive() {
      if (this.dialogSelect == "1") {
        this.datashowAll = [];
        this.print_table_detail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        try {
          await this.loadRef_TypeRcById();
          await this.loadMainInvSoData();
          if (this.currency_print == "THB") {
            await this.loadInvSoData();
          } else {
            await this.loadInvSoDataOth();
          }
          await this.checkcontent();

          // แทนที่บรรทัดนี้:
          // await this.exportToPDF();

          // ด้วยบรรทัดนี้:
          await this.exportReceiptToPDFMake();
        } catch (error) {
          this.$hideLoader();
          //error dialog
          alert("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง");

          // this.$store.state.global_dialog = true;
          // this.setupAlertDialog(
          //   true,
          //   "Data Error",
          //   "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
          //   "text-h5 red--text text-center",
          // );

          return;
        }

        this.$hideLoader();
      } else {
        this.datashowAllDetail = [];
        this.print_table_Rcdetail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        try {
          await this.loadRef_TypeRcDetailById();
          await this.loadMainRcData();
          await this.loadRcData();
          await this.checkcontentdetail();

          // แทนที่บรรทัดนี้:
          // await this.exportToPDFDetail();

          // ด้วยบรรทัดนี้:
          await this.exportReceiptDetailToPDFMake();
        } catch (error) {
          this.$hideLoader();
          //error dialog
          alert("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง");

          // this.$store.state.global_dialog = true;
          // this.setupAlertDialog(
          //   true,
          //   "Data Error",
          //   "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
          //   "text-h5 red--text text-center",
          // );

          return;
        }

        this.$hideLoader();
      }
    },

    async printReceive2() {
      if (this.dialogSelect == "1") {
        this.datashowAll = [];
        this.print_table_detail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcById();
        await this.loadMainInvSoData();
        if (this.currency == "THB") {
          await this.loadInvSoData();
        } else {
          await this.loadInvSoDataOth();
        }
        await this.checkcontent();
        // await this.exportToPDF();
        // เรียกแบบนี้
        await this.exportReceiptToPDFMake();
        this.$hideLoader();
      } else {
        this.datashowAllDetail = [];
        this.print_table_Rcdetail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcDetailById();
        await this.loadMainRcData();
        await this.loadRcData();
        await this.checkcontentdetail();
        // await this.exportToPDFDetail();
        // ใช้ pdfMake สำหรับ Detail แทน html2pdf
        await this.exportReceiptDetailToPDFMake();
        this.$hideLoader();
      }
    },

    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);

            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    formatDate(dateString) {
      console.log("formatDate input =", dateString);

      if (!dateString) return "";
      if (dateString.includes("/")) return dateString;

      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        console.log("Invalid date:", dateString);
        return "";
      }

      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    createHeader() {
      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_thai ||
                  "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text:
                  this.header.com_add_name ||
                  "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_country || "BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createTitle() {
      return {
        stack: [
          {
            text: this.header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: this.header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    createCustomerInfo() {
      const addressLines = (this.header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      // สร้าง array สำหรับข้อมูลด้านขวา
      const rightColumnStack = [
        {
          text: `No. / เลขที่ : ${this.header.inv_id || "________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date / วันที่ : ${this.formatDate(this.header.invoice_date) ||
            "______________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
      ];

      // เพิ่ม Exchange Rate เฉพาะเมื่อไม่ใช่ THB
      if (this.currency_print !== "THB") {
        rightColumnStack.push({
          text: `Exchange Rate : ${this.exchangeRate || "______________"}`,
          fontSize: 9,
          alignment: "right",
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text:
                      filteredAddress ||
                      "Address Line 1, address line 1, address line 1,\nAddress Line 2, address line 2, address line 2, address line 2\nAddress Line 3, address line 3, address line 3, address line 3\nCity, Postcode, COUNTRY",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_taxid || "__________________",
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: rightColumnStack, // ใช้ array ที่สร้างไว้
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createItemsTable() {
      const tableWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const headerRow = [
        {
          text: "No.",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Statement No./ เลขที่ใบเเจ้งหนี้",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Date / วันที่",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      if (this.showCurrencyColumn) {
        headerRow.push({
          text: "Currency / Amount",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        });
      }

      headerRow.push({
        text: "Amount / จำนวนเงิน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      });

      const bodyRows = [];
      const minRows = 7;

      for (let i = 0; i < minRows; i++) {
        if (i < this.items.length) {
          const item = this.items[i];
          const row = [
            {
              text: item.no || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.inv_id || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: this.formatDate(item.date) || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
          ];

          if (this.showCurrencyColumn) {
            row.push({
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            });
          }

          row.push({
            text: item.amount_s ? this.formatNumber(item.amount_s) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          });

          bodyRows.push(row);
        } else {
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];

          if (this.showCurrencyColumn) {
            emptyRow.push({
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            });
          }

          emptyRow.push({
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          });
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function (i, node) {
            // if (i === 0 || i === 1 || i === node.table.body.length) {
            if (i === 0 || i === 1) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function (i) {
            return 1;
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createSummaryTable() {
      const subTotal = this.header.sub_total || 0;
      const subTotalOth = this.header.sub_total_oth || 0;
      const taxRate = this.header.tax_rate || "7.00";
      const taxAmount = this.header.tax_rate_amount || 0;
      const taxAmountOth = this.header.tax_rate_amount_oth || 0;
      const grandTotal = this.header.amount_total || 0;
      const grandTotalOth = this.header.amount_total_oth || 0;
      let currency = this.currencyPrint || "USD";
      currency = currency.replace("US", "USD");
      currency = currency.replace("USDD", "USD");

      const summaryWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const summaryRows = [];

      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        subTotalRow.push({
          text: `${currency} ${this.formatNumber(subTotalOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      subTotalRow.push({
        text: this.formatNumber(subTotal),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(subTotalRow);

      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        vatRow.push({
          text: `${currency} ${this.formatNumber(taxAmountOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      vatRow.push({
        text: this.formatNumber(taxAmount),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(vatRow);

      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        grandTotalRow.push({
          text: `${currency} ${this.formatNumber(grandTotalOth)}`,
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      grandTotalRow.push({
        text: this.formatNumber(grandTotal),
        fontSize: 9,
        bold: true,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i) {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createAmountInWords() {
      const amountText = this.dataToUse.textamount_total_en || "";

      // ตรวจสอบภาษาของ customer_name
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(this.header.customer_name || "");

      // กำหนดข้อความจำนวนเงินตัวอักษรตามภาษา
      let displayText = "";
      if (isThaiCustomer) {
        // ถ้าชื่อลูกค้าเป็นภาษาไทย → แสดงจำนวนเงินเป็นภาษาไทยโดยไม่มีวงเล็บและ currency
        displayText = `${amountText} `;
      } else {
        // ถ้าชื่อลูกค้าเป็นภาษาอังกฤษ → แสดงจำนวนเงินเป็นภาษาอังกฤษพร้อมวงเล็บและ currency
        displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
        displayText = displayText.replace("US", "USD");
        displayText = displayText.replace("USDD", "USD");
      }

      const widths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const cells = [
        {
          text: displayText, // ← ใช้ displayText แทน
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: this.showCurrencyColumn ? 5 : 4,
        },
        {},
      ];

      const emptyCellCount = this.showCurrencyColumn ? 3 : 2;
      for (let i = 0; i < emptyCellCount; i++) {
        cells.push({});
      }

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function () {
            return 0;
          },
          vLineWidth: function () {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createPaymentConditions() {
      const paymentDetail = this.dataToUse.payment_by_print || "";

      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                stack: [
                  {
                    text: "Payment Conditions:",
                    fontSize: 9,
                    bold: true,
                    margin: [2, 5, 2, 3],
                  },
                  {
                    columns: [
                      {
                        width: "25%",
                        text: "☐ Cash/เงินสด",
                        fontSize: 9,
                        margin: [10, 0, 0, 0],
                      },
                      {
                        width: "25%",
                        text: "☐ Transfer/โอนเงิน",
                        fontSize: 9,
                      },
                      {
                        width: "30%",
                        text: "☐ Cheque/เช็คธนาคาร",
                        fontSize: 9,
                      },
                      {
                        width: "20%",
                        text: "No./เลขที่",
                        fontSize: 9,
                      },
                    ],
                    margin: [2, 3, 2, 5],
                  },
                ],
                margin: [2, 0, 2, 0],
              },
            ],
            [
              {
                text: `Payment Details / รายละเอียด:${paymentDetail ? "  " + paymentDetail : ""
                  }`,
                fontSize: 9,
                margin: [2, 5, 2, 20],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function () {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 15],
      };
    },

    createSignatureBox() {
      return {
        columns: [
          {
            width: "50%",
            text: "",
          },
          {
            width: "50%",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    stack: [
                      {
                        text: "",
                        margin: [0, 0, 0, 35],
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 30,
                            y1: 0,
                            x2: 200,
                            y2: 0,
                            lineWidth: 1,
                          },
                        ],
                        margin: [0, 0, 0, 5],
                      },
                      {
                        text: "Authorized Signature / ผู้รับเงิน",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Date/วันที่ _______________________",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                    ],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return "black";
              },
              vLineColor: function () {
                return "black";
              },
            },
          },
        ],
        margin: [0, 0, 0, 15],
      };
    },

    createFooterNote() {
      return {
        stack: [
          {
            text:
              "This receipt will be valid whgn the company has received the payment into the bank account.",
            fontSize: 8,
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          {
            text:
              "ใบเสร็จรับเงินนี้จะสมบูรณ์เมื่อบริษัทได้รับชำระเงินเข้าในบัญชีธนาคารเรียบร้อยแล้ว",
            fontSize: 8,
            alignment: "center",
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },

    generateMainReceipt() {
      const mainContent = [];
      mainContent.push(this.createHeader());
      mainContent.push(this.createTitle());
      mainContent.push(this.createCustomerInfo());
      mainContent.push(this.createItemsTable());
      mainContent.push(this.createSummaryTable());
      mainContent.push(this.createAmountInWords());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());
      return mainContent;
    },

    generateDocDefinition() {
      const mainReceipt = this.generateMainReceipt();
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceipt,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
      return docDefinition;
    },

    async exportReceiptToPDFMake() {
      // สร้างข้อมูลแล้วโยนเข้า mockData
      // this.mockData.main_data = {
      //   datashowAll: this.datashowAll,
      //   print_header: this.print_header,
      //   heighttabledetail: this.heighttabledetail,
      //   currency_print: this.currency_print,
      //   check_cus_name: this.check_cus_name,
      //   textamount_total_en: this.textamount_total_en,
      //   checklawoffice: this.checklawoffice,
      //   exchange_rate: this.exchange_rate,
      //   branch_cus: this.branch_cus,
      //   payment_by_print: this.payment_by_print,
      //   bank_name_show: this.bank_name_show,
      //   bank_no_show: this.bank_no_show,
      // };

      // try {
      //   await this.waitForPdfMakeReady();
      // } catch (error) {
      //   console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
      //   alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
      //   return;
      // }

      // try {
      //   const docDefinition = this.generateDocDefinition();
      //   pdfMake.createPdf(docDefinition).open();
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }

      const receiptData = {
        datashowAll: this.datashowAll,
        print_header: this.print_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
      };

      try {
          //ฟังก์ชันปริ้นเก่า
        // await generateReceiptPDF(receiptData);
         //ฟังก์ชันปริ้นใหม่
                const blob =  await generateReceiptPDF(receiptData);
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    createItemsTableDetail() {
      const tableWidths = ["*", 70, 80]; // 3 คอลัมน์: Description, Quantity, Amount

      const headerRow = [
        {
          text: "Description / รายการ",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Quantity / จำนวน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Amount / จำนวนเงิน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      const bodyRows = [];
      const minRows = 7;

      const detailItems = this.print_table_Rcdetail || [];

      for (let i = 0; i < minRows; i++) {
        if (i < detailItems.length) {
          const item = detailItems[i];
          // console.log(`Detail item ${i}:`, JSON.stringify(item));

          const row = [
            {
              text: item.description || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: item.quantity ? this.formatNumber(item.quantity) : "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            },
          ];

          bodyRows.push(row);
        } else {
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function (i, node) {
            if (i === 0 || i === 1 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function (i) {
            return 1;
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createHeaderDetail() {
      const header = this.print_detail_header || {}; // ใช้ print_detail_header แทน

      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_thai || "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text: header.com_add_name || "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_no || "942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK, BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createTitleDetail() {
      const header = this.print_detail_header || {};

      return {
        stack: [
          {
            text: header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    createCustomerInfoDetail() {
      const header = this.print_detail_header || {};
      const addressLines = (header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      const rightColumnStack = [
        {
          text: `No. / เลขที่ : ${header.inv_id || "________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date / วันที่ : ${this.formatDate(header.invoice_date) ||
            "______________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
      ];

      if (this.currency_print !== "THB") {
        rightColumnStack.push({
          text: `Exchange Rate : ${this.exchange_rate || "______________"}`,
          fontSize: 9,
          alignment: "right",
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text: filteredAddress || "Address",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: header.customer_taxid || "__________________",
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: rightColumnStack,
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createSummaryTableDetail() {
      const header = this.print_detail_header || {};
      const subTotal = header.sub_total || 0;
      const taxRate = header.tax_rate || "7.00";
      const taxAmount = header.tax_rate_amount || 0;
      const grandTotal = header.amount_total || 0;

      const summaryWidths = ["*", 70, 80]; // เปลี่ยนเป็น 3 คอลัมน์

      const summaryRows = [];

      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(subTotal),
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(subTotalRow);

      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(taxAmount),
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(vatRow);

      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(grandTotal),
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i) {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createAmountInWordsDetail() {
      const amountText = this.textamount_total_en || "";
      const header = this.print_detail_header || {};

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(header.customer_name || "");

      let displayText = "";
      if (isThaiCustomer) {
        displayText = `${amountText}`;
      } else {
        displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
        displayText = displayText.replace("US", "USD");
        displayText = displayText.replace("USDD", "USD");
      }

      const widths = ["*", 70, 80]; // เปลี่ยนเป็น 3 คอลัมน์

      const cells = [
        {
          text: displayText,
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: 3, // เปลี่ยนจาก 4 เป็น 3
        },
        {},
        {},
      ];

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function () {
            return 0;
          },
          vLineWidth: function () {
            return 1;
          },
          hLineColor: function () {
            return "black";
          },
          vLineColor: function () {
            return "black";
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // 3. สร้างฟังก์ชัน generateMainReceiptDetail()
    generateMainReceiptDetail() {
      const mainContent = [];
      mainContent.push(this.createHeaderDetail());
      mainContent.push(this.createTitleDetail());
      mainContent.push(this.createCustomerInfoDetail());
      mainContent.push(this.createItemsTableDetail());
      mainContent.push(this.createSummaryTableDetail());
      mainContent.push(this.createAmountInWordsDetail());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());
      return mainContent;
    },

    // 4. สร้างฟังก์ชัน generateDocDefinitionDetail()
    generateDocDefinitionDetail() {
      const mainReceiptDetail = this.generateMainReceiptDetail();
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceiptDetail,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
      return docDefinition;
    },

    // 5. สร้างฟังก์ชันหลัก exportReceiptDetailToPDFMake()
    async exportReceiptDetailToPDFMake() {
      // สร้างข้อมูลแล้วโยนเข้า mockData
      // this.mockData.main_data_detail = {
      //   datashowAllDetail: this.datashowAllDetail,
      //   print_header: this.print_detail_header,
      //   heighttabledetail: this.heighttabledetail,
      //   currency_print: this.currency_print,
      //   check_cus_name: this.check_cus_name,
      //   textamount_total_en: this.textamount_total_en,
      //   checklawoffice: this.checklawoffice,
      //   exchange_rate: this.exchange_rate,
      //   branch_cus: this.branch_cus,
      //   payment_by_print: this.payment_by_print,
      //   bank_name_show: this.bank_name_show,
      //   bank_no_show: this.bank_no_show,
      //   currency_show: this.currency_show,
      // };

      // // console.log(
      // //   `Mock Data Detail:`,
      // //   JSON.stringify(this.mockData.main_data_detail)
      // // );

      // try {
      //   await this.waitForPdfMakeReady();
      // } catch (error) {
      //   console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
      //   alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
      //   return;
      // }

      // try {
      //   const docDefinition = this.generateDocDefinitionDetail();
      //   pdfMake.createPdf(docDefinition).open();
      //   console.log("✅ สร้าง Receipt Detail PDF สำเร็จ");
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }

      const receiptDetailData = {
        datashowAllDetail: this.datashowAllDetail,
        print_header: this.print_detail_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
        currency_show: this.currency_show,
      };

      try {
        // เปิดใน tab ใหม่
         //ฟังก์ชันปริ้นเก่า
        // await generateReceiptDetailPDF(receiptDetailData);

                 //ฟังก์ชันปริ้นใหม่
                const blob =  await generateReceiptDetailPDF(receiptDetailData);
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;

        // หรือดาวน์โหลดไฟล์
        // await downloadReceiptDetailPDF(receiptDetailData, 'receipt-detail-001.pdf');

        // หรือพิมพ์โดยตรง
        // await printReceiptDetailPDF(receiptDetailData);
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    //print end
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async SumDataT() {
      let sum_data = 0;
      this.mDataArray.forEach((item) => {
        item.inv_lineamount = Number(stringcommatonumber(item.inv_lineamount));
        sum_data = sum_data + item.inv_lineamount;
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);
      });
      if (this.vat_type == "E") {
        this.inv_subtotal = tolocalestringnumber(sum_data);
        this.wth_ratetotal = 0;
        // this.wth_ratetotal = tolocalestringnumber(Number(this.wth_rate)/100 * sum_data);
        this.tax_ratetotal = tolocalestringnumber(
          Number((this.vat / 100) * sum_data),
        );
        this.amount_total = tolocalestringnumber(
          sum_data + Number((this.vat / 100) * sum_data),
        );
        // this.amount_total = tolocalestringnumber(sum_data - (Number(this.wth_rate)/100 * sum_data) +(Number(this.vat/100 * sum_data)));
      } else if (this.vat_type == "I") {
        this.amount_total = tolocalestringnumber(sum_data);
        // this.amount_total = tolocalestringnumber(sum_data /(1+Number(this.wth_rate)/100 ));
        this.wth_ratetotal = 0;
        // this.wth_ratetotal = tolocalestringnumber(Number(sum_data - stringcommatonumber(this.amount_total)).toFixed(2));
        this.inv_subtotal = tolocalestringnumber(
          Number(
            stringcommatonumber(this.amount_total) / (1 + this.vat / 100),
          ).toFixed(2),
        );
        this.tax_ratetotal = tolocalestringnumber(
          Number(
            stringcommatonumber(this.amount_total) -
            stringcommatonumber(this.inv_subtotal),
          ).toFixed(2),
        );
      } else {
      }
    },
    async loadInvByID() {
      // console.log("start loadInv");

      if (!this.inv_id_by) {
        // console.warn("inv_id_by is not set. Skipping loadInvByID.");
        return;
      }

      const res_inv = await api.billing_expense_getdataByIdInvoice_HRC(
        this.inv_id_by,
      );
      // console.log(`loadInvByID: ${JSON.stringify(res_inv.data)}`);
      this.branch = res_inv.data[0].customer_branch;
      this.payment_term = res_inv.data[0].customer_paymentterm;
      this.attention = res_inv.data[0].attention;
      this.po_no = res_inv.data[0].po_no;
      // this.wth_rate = res_inv.data[0].wth_rate;
      // this.vat_type = res_inv.data[0].vat_type;
      await this.SumDataT();
    },

    async loaddataRc() {
      this.main_id = this.$route.params.id;
      const res_rc = await api.billing_expense_getDataReceiveByID(this.main_id);

      this.main_customer_id = res_rc.data[0].customer_id;
      this.payment_by = res_rc.data[0].payment_by;
      this.bank_name = res_rc.data[0].bank_name;
      this.bank_no = res_rc.data[0].bank_no;
      this.payment_comment = res_rc.data[0].payment_comment;
      this.company_trc = res_rc.data[0].company_trc;
      this.vat = res_rc.data[0].tax_rate;
      this.amoumt_t = res_rc.data[0].trc_amoumt;
      if (res_rc.data[0].trc_id != null) {
        this.showinv_rid = res_rc.data[0].trc_id;
      }
      this.exchange_rate = res_rc.data[0].exchange_rate;
      this.date_rc = new Date(res_rc.data[0].trc_date_show)
        .toISOString()
        .substr(0, 10);

      console.log("this.date_rc: " + this.date_rc)
    },
    async loadCustomer() {
      if (this.main_customer_id != 0) {
        const res_customer = await api.getCustomersById(this.main_customer_id);
        this.customer_data = res_customer.data;

        //set data
        this.customer_code = this.customer_data[0].cust_account;
        this.customer_name = this.customer_data[0].name;
        this.invoice_address = this.customer_data[0].address_invoice;
        this.currency = this.customer_data[0].currency;
        this.currency_print = this.customer_data[0].currency;
        this.payment_term = this.customer_data[0].payment_term;
        this.tax_id = this.customer_data[0].taxid;
        this.vat_type = this.customer_data[0].vat_type;
      }
    },
    async loaddataRc_D() {
      let inv_docref = "";

      const res_rc_detailData = await api.billing_expensegetDataReceiveDByID(
        this.main_id,
      );

      // ✅ guard: ถ้าไม่มีข้อมูล ออกจากฟังก์ชันอย่างปลอดภัย
      const dataset = res_rc_detailData?.data;
      if (!Array.isArray(dataset) || dataset.length === 0) {
        this.desserts = [];
        this.mDataArray = [];
        this.inv_id_by = null;
        return; // ให้ flow อื่นทำงานต่อได้ ไม่ throw
      }

      if (dataset[0].status == 2) {
        this.status_check = true;
      }

      this.desserts = dataset;

      this.desserts.forEach((item, index) => {
        item.inv_qty = tolocalestringnumber(item.inv_qty);

        item.inv_price = tolocalestringnumber(
          item.inv_lineamount / item.inv_qty,
        );
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);
        if (!item.inv_qty || isNaN(item.inv_qty) || item.inv_qty == "") {
          item.inv_qty = tolocalestringnumber(0);
        }
        if (
          !item.inv_price ||
          item.inv_price == "" ||
          item.inv_price == "NaN"
        ) {
          item.inv_price = tolocalestringnumber(0);
        }
        if (
          !item.inv_lineamount ||
          item.inv_lineamount == "NaN" ||
          item.inv_lineamount == ""
        ) {
          item.inv_lineamount = tolocalestringnumber(0);
        }
        if (index < this.desserts.length - 1) {
          inv_docref = inv_docref + item.inv_hid + ",";
        } else {
          inv_docref = inv_docref + item.inv_hid;
        }
      });

      this.mDataArray = this.desserts;

      const res_docRef = await api.billing_expense_getReceiveDetail("INV_REF", {
        id: inv_docref,
      });

      // ✅ guard: เช็คก่อนเข้าถึง .data และ [0]
      if (res_docRef?.data?.length > 0) {
        this.res_docRef = res_docRef.data;
        let inv_id_s = "";
        this.res_docRef.forEach((item, index) => {
          if (index < this.res_docRef.length - 1) {
            inv_id_s = inv_id_s + item.inv_id + ",";
          } else {
            inv_id_s = inv_id_s + item.inv_id;
          }
        });
        this.doc_ref = inv_id_s;
        this.inv_id_by = res_docRef.data[0].id;
      } else {
        this.inv_id_by = null;
      }
    },
    async openeditItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dataedit_service.inv_seq = item.inv_seq;
      this.dataedit_service.inv_detail = item.inv_detail;
      this.dataedit_service.inv_qty = stringcommatonumber(item.inv_qty);
      this.dataedit_service.inv_price = stringcommatonumber(item.inv_price);
      this.dataedit_service.inv_lineamount = item.inv_lineamount;
      this.dialogEdit = true;
    },
    async closeeditItem() {
      this.dialogEdit = false;
    },
    async calserviceamount() {
      this.dataedit_service.inv_lineamount = parseFloat(
        this.dataedit_service.inv_qty * this.dataedit_service.inv_price,
      );
      this.dataedit_service.inv_lineamount = tolocalestringnumber(
        this.dataedit_service.inv_lineamount,
      );
    },
    async saveeditItem() {
      this.desserts[
        this.editedIndex
      ].inv_detail = this.dataedit_service.inv_detail;
      this.desserts[this.editedIndex].inv_qty = tolocalestringnumber(
        this.dataedit_service.inv_qty,
      );
      this.desserts[this.editedIndex].inv_price = tolocalestringnumber(
        this.dataedit_service.inv_price,
      );
      this.desserts[
        this.editedIndex
      ].inv_lineamount = this.dataedit_service.inv_lineamount;
      this.dialogEdit = false;
      await this.SumDataT();
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dialogDeleteServic = true;
    },
    closeDeleteService() {
      this.dialogDeleteServic = false;
    },
    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.desserts.forEach((item, index) => {
        if (index >= this.editedIndex) {
          item.inv_seq = item.inv_seq - 1;
        }
      });
      this.dialogDeleteServic = false;
      await this.SumDataT();
    },
    async saveinvDraft() {
      // alert(this.exchange_rate)
      if (this.exchange_rate == 0 || this.exchange_rate == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please Enter Exchange Rate Data",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.mDataArray.length < 1) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please provide the invoice details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.dataAddRc_H.trc_amoumt = Number(
        stringcommatonumber(this.amount_total),
      );
      this.dataAddRc_H.trc_sub_amoumt = Number(
        stringcommatonumber(this.inv_subtotal),
      );
      this.dataAddRc_H.exchange_rate = this.exchange_rate;
      this.dataAddRc_H.vat_type = this.vat_type;
      this.dataAddRc_H.payment_by = this.payment_by;

      this.dataAddRc_H.bank_name = this.bank_name;
      this.dataAddRc_H.bank_no = this.bank_no;

      this.dataAddRc_H.payment_comment = this.payment_comment;
      this.dataAddRc_H.user_update = localStorage.getItem(server.USER_ID);
      this.dataAddRc_H.company_trc = this.company_trc;
      this.dataAddRc_H.trc_tax = Number(
        stringcommatonumber(this.tax_ratetotal),
      );
      this.dataAddRc_H.trc_date = this.date_rc;
      this.$showLoader();
      const res_updateData = await api.billing_expense_updateReceiveH(
        this.main_id,
        "Draft",
        this.dataAddRc_H,
      );
      if (res_updateData.status == 200 || res_updateData.status == 201) {
        await api.billing_expensedeleteReceiveD(this.main_id);
        this.desserts.forEach(async (item) => {
          this.dataAddRc_D.trc_hid = this.main_id;
          this.dataAddRc_D.inv_seq = item.inv_seq;
          this.dataAddRc_D.inv_hid = item.inv_hid;
          this.dataAddRc_D.inv_detail = item.inv_detail;
          this.dataAddRc_D.inv_qty = Number(stringcommatonumber(item.inv_qty));
          this.dataAddRc_D.inv_lineamount = Number(
            stringcommatonumber(item.inv_lineamount),
          );
          this.dataAddRc_D.user_create = Number(
            localStorage.getItem(server.USER_ID),
          );
          this.dataAddRc_D.user_update = Number(
            localStorage.getItem(server.USER_ID),
          );
          await api.billing_expenseCreateDataReceiveD(this.dataAddRc_D);
        });
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/reloadpage`,
        );
      } else {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ผิดพลาด",
          "บันทึกข้อมูลไม่สำเร็จ",
          "text-h5 red--text text-center",
          "/receive",
        );
        this.$hideLoader();
      }
    },
    async saveinvSubmit() {
      if (this.exchange_rate == 0 || this.exchange_rate == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please Enter Exchange Rate Data",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.mDataArray.length < 1) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Please provide the invoice details.",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.dataAddRc_H.trc_amoumt = Number(
        stringcommatonumber(this.amount_total),
      );
      this.dataAddRc_H.trc_sub_amoumt = Number(
        stringcommatonumber(this.inv_subtotal),
      );
      this.dataAddRc_H.payment_by = this.payment_by;
      this.dataAddRc_H.exchange_rate = this.exchange_rate;
      this.dataAddRc_H.vat_type = this.vat_type;
      this.dataAddRc_H.payment_comment = this.payment_comment;

      this.dataAddRc_H.bank_name = this.bank_name;
      this.dataAddRc_H.bank_no = this.bank_no;

      this.dataAddRc_H.company_trc = this.company_trc;
      this.dataAddRc_H.trc_tax = Number(
        stringcommatonumber(this.tax_ratetotal),
      );
      this.dataAddRc_H.status = 2;
      this.dataAddRc_H.user_update = localStorage.getItem(server.USER_ID);

      this.dataAddRc_H.trc_date = this.date_rc;

      this.$showLoader();
      const res_updateData = await api.billing_expense_updateReceiveH(
        this.main_id,
        "Summit",
        this.dataAddRc_H,
      );
      if (res_updateData.status == 200 || res_updateData.status == 201) {
        await api.billing_expensedeleteReceiveD(this.main_id);
        this.desserts.forEach(async (item) => {
          this.dataAddRc_D.trc_hid = this.main_id;
          this.dataAddRc_D.inv_seq = item.inv_seq;
          this.dataAddRc_D.inv_hid = item.inv_hid;
          this.dataAddRc_D.inv_detail = item.inv_detail;
          this.dataAddRc_D.inv_qty = Number(stringcommatonumber(item.inv_qty));
          this.dataAddRc_D.inv_lineamount = Number(
            stringcommatonumber(item.inv_lineamount),
          );
          this.dataAddRc_D.user_create = Number(
            localStorage.getItem(server.USER_ID),
          );
          this.dataAddRc_D.user_update = Number(
            localStorage.getItem(server.USER_ID),
          );
          await api.billing_expenseCreateDataReceiveD(this.dataAddRc_D);
        });
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/reloadpage`,
        );
      } else {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ผิดพลาด",
          "บันทึกข้อมูลไม่สำเร็จ",
          "text-h5 red--text text-center",
          "/receive",
        );
        this.$hideLoader();
      }
    },
    async deleteReceive() {
      this.dialogDeleteRecevie = true;
    },
    closeDeleteRecive() {
      this.dialogDeleteRecevie = false;
    },
    async deleteReceiveConfirm() {
      this.$showLoader();
      await api.billing_expense_deleteReceiveH(this.main_id);
      await api.billing_expensedeleteReceiveD(this.main_id);
      this.res_docRef.forEach(async (item) => {
        await api.billing_expense_clearStatusInv(item.id, item.inv_type);
      });
      this.dialogDeleteRecevie = false;
      this.$hideLoader();
      this.$store.state.global_push_dialog = true;
      this.setupAlertDialogPush(
        true,
        "Information Saved",
        "Information successfully saved",
        "text-h5 green--text text-center",
        "/receive",
      );
    },
    async onSelectvat_type() { },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;

    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
